import { Fab, TextField, Tooltip } from "@material-ui/core";
import { SaveAlt, Search } from "@material-ui/icons";
import { Box, Grid } from "@mui/material";
import DateRangePicker from "components/date-picker/DateRangePicker";
import Select from "components/select/Select";
import SelectProvinceTypeExtension from "components/select-province-type/SelectProvinceTypeExtension";
import { ALL_OPTION } from "constant";
import { useFormik } from "formik";
import { useEffect, useRef } from "react";
import { getDateRangePickerFieldProps, getTextFieldProps } from "ultis/form";
import * as Yup from "yup";

const LIST_EXTENSION_STATUS = [
  {
    label: "Đang hoạt động",
    value: "false",
  },
  {
    label: "Ngừng hoạt động",
    value: "true",
  },
];

const extensionValidateSchema = Yup.object().shape({
  typeProvince: Yup.string().required("Không được trống"),
  code: Yup.array().min(1, "Không được trống"),
});

const ReportLicenseBCPFilter = ({ onSubmit, onExport, isDisabledExport }) => {
  const isFirstRender = useRef(true);
  const defaultFrom = new Date();
  defaultFrom.setHours(0, 0, 0, 0);
  const defaultTo = new Date(defaultFrom);
  defaultTo.setHours(23, 59, 59, 999);

  const formik = useFormik({
    initialValues: {
      nameExtension: "",
      isDeleted: ALL_OPTION.value,
      typeProvince: "",
      dateRange: [defaultFrom, defaultTo],
      code: [],
    },
    validationSchema: extensionValidateSchema,
    onSubmit,
  });

  useEffect(() => {
    if (isFirstRender.current) {
      extensionValidateSchema
        .validate(formik.values)
        .then(() => {
          isFirstRender.current = false;
          formik.handleSubmit();
        })
        .catch(() => {});
    }
  }, [formik]);
  return (
    <form onSubmit={formik.handleSubmit}>
      <Box sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <SelectProvinceTypeExtension formik={formik} />
          </Grid>

          <Grid item xs={3}>
            <TextField
              {...getTextFieldProps(formik, "nameExtension")}
              label="Máy lẻ"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              autoComplete="off"
            />
          </Grid>
          <Grid item xs={4}>
            <DateRangePicker
              {...getDateRangePickerFieldProps(formik, "dateRange")}
              isTime
              startDateLabel="Thời gian khởi tạo"
              endDateLabel="Thời gian đóng"
            />
          </Grid>

          <Grid item xs={2}>
            <Select
              label="Trạng thái"
              options={LIST_EXTENSION_STATUS}
              value={formik.values.isDeleted}
              onChange={(newValue) =>
                formik.setFieldValue("isDeleted", newValue)
              }
              showAllOption
            />
          </Grid>

          <Grid item xs={2}>
            <Tooltip title="Tìm kiếm" disableFocusListener>
              <Fab color="primary" aria-label="Search" type="submit">
                <Search />
              </Fab>
            </Tooltip>
            <Tooltip title="Tải báo cáo" disableFocusListener>
              <Fab
                color="primary"
                aria-label="Search"
                style={{ marginLeft: "10px" }}
                onClick={onExport}
                disabled={isDisabledExport}>
                <SaveAlt />
              </Fab>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export default ReportLicenseBCPFilter;
